import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PortalRole = 'student' | 'parent';

interface PortalAuth {
  role: PortalRole;
  accessToken: string;
  userId: string;
  displayName: string;
  tenantSlug: string;
  tenantName: string;
}

interface PortalStore {
  auth: PortalAuth | null;
  isAuthenticated: boolean;
  setAuth: (auth: PortalAuth) => void;
  setAccessToken: (token: string) => void;
  clearAuth: () => void;
}

export const usePortalStore = create<PortalStore>()(
  persist(
    (set, get) => ({
      auth: null,
      isAuthenticated: false,
      setAuth: (auth) => set({ auth, isAuthenticated: true }),
      setAccessToken: (token) => {
        const auth = get().auth;
        if (auth) set({ auth: { ...auth, accessToken: token } });
      },
      clearAuth: () => set({ auth: null, isAuthenticated: false }),
    }),
    {
      name: 'usms-portal',
      partialize: (s) => ({ auth: s.auth ? { ...s.auth, accessToken: undefined } : null }),
    }
  )
);
